import { message } from "antd";
import { apiBase } from "../utils/apiBase";
import { get } from "lodash";

export const types = {
  CALL_QUEUE_SET: "CALL_QUEUE_SET",
  CALL_QUEUE_SET_LOADING: "CALL_QUEUE_SET_LOADING",
  CALL_QUEUE_SET_CURRENT_INDEX: "CALL_QUEUE_SET_CURRENT_INDEX",
  CALL_QUEUE_SET_PIPEDRIVE_USER_ID: "CALL_QUEUE_SET_PIPEDRIVE_USER_ID",
  CALL_QUEUE_SET_INCLUDE_NTF: "CALL_QUEUE_SET_INCLUDE_NTF",
  CALL_QUEUE_SET_QUEUE_TYPE: "CALL_QUEUE_SET_QUEUE_TYPE",
};

export const setCallQueue = (value) => ({
  type: types.CALL_QUEUE_SET,
  value,
});

export const setLoading = (value) => ({
  type: types.CALL_QUEUE_SET_LOADING,
  value,
});

export const setCurrentIndex = (value) => ({
  type: types.CALL_QUEUE_SET_CURRENT_INDEX,
  value,
});

export const setPipedriveUserId = (value) => ({
  type: types.CALL_QUEUE_SET_PIPEDRIVE_USER_ID,
  value,
});

export const setIncludeNtf = (value) => ({
  type: types.CALL_QUEUE_SET_INCLUDE_NTF,
  value,
});

export const setQueueType = (value) => ({
  type: types.CALL_QUEUE_SET_QUEUE_TYPE,
  value,
});

export const getCallQueue =
  (pipedriveUserId, includeNtf, queueType) => (dispatch, getState) => {
    const { callQueue } = getState();
    const idToUse =
      pipedriveUserId !== undefined
        ? pipedriveUserId
        : callQueue.pipedriveUserId;
    const includeNtfToUse =
      includeNtf !== undefined ? includeNtf : callQueue.includeNtf;
    const queueTypeToUse =
      queueType !== undefined ? queueType : callQueue.queueType;
    dispatch(setLoading(true));
    return apiBase
      .get(`calls/queue`, {
        params: {
          pipedrive_user_id: idToUse || "",
          include_ntf: includeNtfToUse,
          queue_type: queueTypeToUse,
        },
      })
      .then((res) => {
        dispatch(setCallQueue(get(res, "data.call_queue", [])));
        dispatch(setLoading(false));
      })
      .catch((err) => {
        dispatch(setCallQueue([]));
        dispatch(setLoading(false));
        message.error("Failed to load call queue.");
      });
  };

export const nextOwner = () => (dispatch, getState) => {
  const { callQueue } = getState();
  const { data, currentIndex } = callQueue;
  if (currentIndex < data.length - 1) {
    dispatch(setCurrentIndex(currentIndex + 1));
  }
};

export const previousOwner = () => (dispatch, getState) => {
  const { callQueue } = getState();
  const { currentIndex } = callQueue;
  if (currentIndex > 0) {
    dispatch(setCurrentIndex(currentIndex - 1));
  }
};

export const initialState = {
  data: [],
  loading: false,
  currentIndex: 0,
  pipedriveUserId: null,
  includeNtf: true,
  queueType: "new",
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case types.CALL_QUEUE_SET:
      return { ...state, data: action.value };
    case types.CALL_QUEUE_SET_LOADING:
      return { ...state, loading: action.value };
    case types.CALL_QUEUE_SET_CURRENT_INDEX:
      return { ...state, currentIndex: action.value };
    case types.CALL_QUEUE_SET_PIPEDRIVE_USER_ID:
      return { ...state, pipedriveUserId: action.value };
    case types.CALL_QUEUE_SET_INCLUDE_NTF:
      return { ...state, includeNtf: action.value };
    case types.CALL_QUEUE_SET_QUEUE_TYPE:
      return { ...state, queueType: action.value };
    default:
      return state;
  }
}

export default {
  getCallQueue,
  setCallQueue,
  setLoading,
  setCurrentIndex,
  setPipedriveUserId,
  setIncludeNtf,
  setQueueType,
  nextOwner,
  previousOwner,
};
